module.exports = __webpack_public_path__ + "static/gbh_logo_purple_rgb-7db2ac40f5450a097135960af9f2bc86.png";